document.addEventListener("DOMContentLoaded", () => {
    const elements = {
        account: document.getElementById("account"),
        submenu: document.querySelector("header .sub-menu")
    };
    if(elements.account && elements.submenu) {
        elements.account.addEventListener("click", () => {
            if(elements.submenu.classList.contains("open")) {
                elements.submenu.classList.remove("open")
            } else {
                elements.submenu.classList.add("open")
            }
        })
    }
});